import checkout from '../modules/checkoutModule';
import filteredProducts from "../modules/filter/filteredProducts";
import initCustomForms from '../modules/initCustomForms';
import initPopups from '../modules/initPopups';
import scrollHidden from '../modules/scrollHidden';
import header from '../modules/header/index';
import addToCardEventInit from "../modules/addToCardEvent";

jQuery(function () {
    header();
    initCustomForms();
    initPopups();
    scrollHidden();
    checkout();

    const $dataContainer = $('.data-container');
    const title = $dataContainer.attr('data-title');
    const metaDescription = $dataContainer.attr('data-meta-description');

    filteredProducts({
        showCatalog: true,
        showCategory: true,
        showGroup: true,
        showBrand: true,
        updateGroupFilter: true,
        updateBrandFilter: true,
        apiUrl: '/umbraco/api/products/GetPaginatedActions',
        title,
        metaDescription
    });
    addToCardEventInit();
})